import { h } from '@debbie/cortex/dist/index.js';
import { useTeams } from '@debbie/cortex/dist/teams/index.js';
import { useUsers } from '@debbie/cortex/dist/users/index.js';
import React from 'react';
import TeamPreview from './TeamPreview.js';
import UserPreview from './UserPreview.js';
const ResponsiblePreview = (props) => {
    const { responsibleType, responsibleReferenceId, style, active, onClick } = props;
    const usersLoadable = useUsers();
    const allUsers = h.hasData(usersLoadable) ? usersLoadable.data : null;
    const allTeamsLoadable = useTeams();
    const allTeams = h.hasData(allTeamsLoadable) ? allTeamsLoadable.data : null;
    const user = (allUsers || []).find((t) => t.id === responsibleReferenceId);
    const team = (allTeams || []).find((t) => t.id === responsibleReferenceId);
    return (React.createElement("div", null, responsibleType === 'user'
        ? user && (React.createElement(UserPreview, { user: user, active: active, onClick: onClick, style: style }))
        : team && (React.createElement(TeamPreview, { team: team, active: active, onClick: onClick, style: style }))));
};
export default ResponsiblePreview;
//# sourceMappingURL=ResponsiblePreview.js.map